import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {SystemSettings} from "../interface/system-settings";

@Injectable({
    providedIn: 'root'
})
export class SystemSettingsService {

    private baseUrl = environment.apiBaseUrl;

    constructor(private http: HttpClient) { }

    get(id: number): Observable<any>{
        return this.http.get(`${this.baseUrl}/get/system-settings/${id}`);
    }

    getCollection(): Observable<SystemSettings[]>{
        return this.http.get<SystemSettings[]>(`${this.baseUrl}/get/system-settings`);
    }

    post(data: SystemSettings): Observable<any>{
        return this.http.post<SystemSettings>(`${this.baseUrl}/create/system-settings`, data);
    }

    put(id: number, data: SystemSettings): Observable<any>{
        return this.http.put<SystemSettings>(`${this.baseUrl}/edit/system-settings/${id}`, data);
    }

    delete(id: number): Observable<SystemSettings>{
        return this.http.delete<SystemSettings>(`${this.baseUrl}/delete/system-settings/` + id);
    }

}
